module.exports.CONSOLE_VERSION = '3.8.0.57'
